export default "__VITE_ASSET__80e112ef__"